import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./signup.css";

import { toast } from "react-toastify";
import Modal from "react-modal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import Loader3Orange from "../../general/Loader3Orange";
import { getBrokerInformation } from "../../store/broker";
import { createCharge, createChargeSuccess } from "../../store/myquotes";

const publicKey = process.env.REACT_APP_STRIPE_KEY;
const stripePromise = loadStripe(publicKey);
const Payment = (props) => {
  const [modal, setModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disable, setDisable] = useState(false);
  const [messageDisplay, setMessageDisplay] = useState("");
  const broker = useSelector(getBrokerInformation);
  const chargeData = useSelector(createChargeSuccess);
  const dispatch = useDispatch();

  const handleSubmit = (cardData) => {
    console.log(cardData);
    if (cardData.token) {
      setMessageDisplay("Card Added Successfully");
    } else if (cardData.error) {
      setMessageDisplay(cardData.error.message);
    } else {
      setMessageDisplay("");
    }
    props.handleCardData(cardData);
  };
  return (
    <div>
      {messageDisplay ? (
        <p
          style={{ textAlign: "center", marginTop: "20px" }}
          className="text-info"
        >
          <b>{messageDisplay}</b>
        </p>
      ) : null}
      <div className="App">
        <div className="product">
          <div>
            <Elements stripe={stripePromise}>
              <CheckoutForm data={props.data} handleSubmit={handleSubmit} />
            </Elements>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
